module.exports = __webpack_public_path__ + "static/Lessons on Common Law, Equity, and Constitutional Remedies-0dcc9352e0b8ce2b75f88d1169ca6a37.jpg";